
import  Aura  from '@primeuix/themes/aura';

import { definePreset, palette } from '@primeuix/themes';
export const DefaultStyles = definePreset(Aura, {
    //Your customizations, see the following sections for examples
    semantic: {
      iconSize: '1.5rem',
      formField: {
        paddingY: '0.825rem',
        paddingX: '1rem',
      },
      primary: palette('#222222'),
      colorScheme: {
        light: {
          surface: {
              0: '#ffffff',
              50: '{zinc.50}',
              100: '{zinc.100}',
              200: '{zinc.200}',
              300: '{zinc.300}',
              400: '{zinc.400}',
              500: '{zinc.500}',
              600: '{zinc.600}',
              700: '{zinc.700}',
              800: '{zinc.800}',
              900: '{zinc.900}',
              950: '{zinc.950}'
          }
        },
        dark: {
          surface: {
              0: '#ffffff',
              50: '{slate.50}',
              100: '{slate.100}',
              200: '{slate.200}',
              300: '{slate.300}',
              400: '{slate.400}',
              500: '{slate.500}',
              600: '{slate.600}',
              700: '{slate.700}',
              800: '{slate.800}',
              900: '{slate.900}',
              950: '{slate.950}'
          }
        }
      }
    },
    components: {
      inputtext: {
        root: {
          placeholderColor: '{surface.300}'
        }
      },
      datepicker: {
        date: {
          borderRadius: '2px',
          padding: '0',
          width: '3rem',
          height: '3rem'
        },
        colorScheme: {
          light: {
            dropdown: {
              background: '#FFFFFF'
            }
          }
        }
      },
      tabs: {
        tablist: {
          background: 'transparent',
          borderWidth: '0'
        },
        tabpanel: {
          background: 'transparent',
          padding: '0'
        },
        tab: {
          activeBackground: '{surface.200}',
          color: '#000',
          hoverBackground: '{surface.200}',
          margin: '0 0.5rem 0 0'
        }
      },
      galleria: {
        root: {
          borderRadius: '0',
          borderWidth: '0',
        },
        thumbnailsContent: {
          background: 'rgba(0,0,0,0.7)'
        }
      },
      accordion: {
        panel: {
          borderColor: '{surface.300}',
          borderWidth: "1px",
        },
        header: {
          background: "transparent",
          padding: '0.5rem',
          borderColor: '{surface.300}',
          borderWidth: "0",
          activeBackground: "transparent",
          first: {
            borderWidth: "0",
          }
        },
        content: {
          borderColor: '{surface.300}',
          borderWidth: "0",
          padding: "0",
          background: "transparent"
        }
      },
      togglebutton: {
        colorScheme: {
          light: {
              
              content: {
                checkedBackground: '{primary.color}'
              },
              root: {
                checkedColor: 'white'
              }
          }
        }
      }
    }
  });